// extracted by mini-css-extract-plugin
export default {"comments":"Feedback_comments__OxcXR"};